<template>
  <div class="advantage">
    <div class="body">
      <div class="title">¿Cuáles son nuestras ventajas?</div>

      <div class="items">
        <div class="item">
          <img src="@/assets/icon1.png" class="left" />
          <div class="right">
            <div class="t1">Enviar una solicitud</div>
            <div class="t2">
              Se puede solicitar después de rellenar la información básica.
            </div>
          </div>
        </div>

        <div class="item">
          <img src="@/assets/icon2.png" class="left" />
          <div class="right">
            <div class="t1">Espera la revisión</div>
            <div class="t2">Revisaremos su información rápidamente, así que tenga paciencia.</div>
          </div>
        </div>

        <div class="item">
          <img src="@/assets/icon3.png" class="left" />
          <div class="right">
            <div class="t1">Obtenga el préstamo</div>
            <div class="t2">Una vez confirmado tu préstamo, recibirás tu dinero en cuestión de minutos.</div>
          </div>
        </div>

      
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "advantageView",
  data() {
    return {};
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>
<style scoped lang="scss">
@media (min-width: 680px) {
  .advantage {
    background:  #F4FCF2;
    width: 100%;
    padding: 70px 0px;
    .body {
      max-width: 1080px;
      width: 100%;
      margin: 0 auto;
      .title {
        font-weight: bold;
font-size: 30px;
color: #3D3D3D;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .items {
        margin-top: 44px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .item {
          padding: 24px 20px;
          background: #FFFFFF;
          border-radius: 12px 12px 12px 12px;
          margin: 12px;
          display: flex;
          align-items: center;
          flex-direction: column;
         
          .left {
            width: 69px;
           
          }
          .right {
            width: 250px;
            .t1 {
     
font-weight: bold;
font-size: 15px;
color: #3D3D3D;

text-align: center;
margin-top: 20px;
margin-bottom: 8px;
            }
            .t2 {
             font-weight: 500;
font-size: 14px;
color: #6B6B6B;
line-height: 22px;
               text-align: center;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 680px) {
  .advantage {
    background:  #F4FCF2;
    width: 100%;
    padding: 30px 0px;
    .body {
      width: 100%;
      margin: 0 auto;
      .title {
        font-weight: bold;
        font-size: 19px;
        color: #3D3D3D;

        text-align: center;
        font-style: normal;
        text-transform: none;
      }

     
      .items {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .item {
          padding: 24px 20px;
          background: #FFFFFF;
          border-radius: 12px 12px 12px 12px;
          margin: 12px;
          display: flex;
          align-items: center;
          flex-direction: column;
         
          .left {
            width: 69px;
           
          }
          .right {
            width: 250px;
            .t1 {
     
font-weight: bold;
font-size: 15px;
color: #3D3D3D;

text-align: center;
margin-top: 20px;
margin-bottom: 8px;
            }
            .t2 {
             font-weight: 500;
font-size: 14px;
color: #6B6B6B;
line-height: 22px;
               text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
